import { DateField, TextField } from '@mi-front/ui';
import moment from 'moment-timezone';

import { useIntl } from 'react-intl';

export function ScheduleStatusMentionsForm(p: object) {
  const { $t } = useIntl();

  return (
    <div className="">
      <div className="row">
        <div className="col-3">
          <DateField
            name="date"
            label={$t({
              id: 'common.date',
              defaultMessage: 'Fecha',
            })}
            isOutsideRange={(date) => moment(date) > moment()}
          />
        </div>
        <div className={'col-md-3'}>
          <TextField
            name="customId"
            label={$t({
              id: 'audit.props.customId',
              defaultMessage: 'Custom ID',
            })}
            placeholder={$t({
              id: 'audit.scheduleStatusScreen.filter.idPlaceholder',
              defaultMessage: 'Todos',
            })}
          />
        </div>
      </div>
    </div>
  );
}
